export const IndiaState = {
  India: {
    Punjab: {
      districts: {
        Amritsar: {
          cities: ["Amritsar", "Tarn Taran"],
        },
        Gurdaspur: {
          cities: ["Gurdaspur", "Pathankot"],
        },
        Ludhiana: {
          cities: ["Ludhiana", "Moga"],
        },
        Patiala: {
          cities: ["Patiala", "Fatehgarh Sahib"],
        },
        Jalandhar: {
          cities: ["Jalandhar", "Phagwara"],
        },
        Bathinda: {
          cities: ["Bathinda", "Rampura Phul"],
        },
        Hoshiarpur: {
          cities: ["Hoshiarpur", "Garhshankar"],
        },
        Ferozepur: {
          cities: ["Ferozepur", "Zira"],
        },
        Mansa: {
          cities: ["Mansa", "Budhlada"],
        },
        Sangrur: {
          cities: ["Sangrur", "Malerkotla"],
        },
        Faridkot: {
          cities: ["Faridkot", "Kotkapura"],
        },
        Fazilka: {
          cities: ["Fazilka", "Abohar"],
        },
        Kapurthala: {
          cities: ["Kapurthala", "Sultanpur Lodhi"],
        },
        Mohali: {
          cities: ["Mohali", "Kharar"],
        },
        Rupnagar: {
          cities: ["Rupnagar", "Anandpur Sahib"],
        },
        Barnala: {
          cities: ["Barnala", "Tapa"],
        },
        Muktsar: {
          cities: ["Muktsar", "Malout"],
        },
        Pathankot: {
          cities: ["Pathankot", "Sujanpur"],
        },
      },
    },
    Haryana: {
      districts: {
        Ambala: {
          cities: ["Ambala City", "Ambala Cantt"],
        },
        Panchkula: {
          cities: ["Panchkula"],
        },
        Rohtak: {
          cities: ["Rohtak"],
        },
        Gurgaon: {
          cities: ["Gurgaon", "Manesar"],
        },
        Faridabad: {
          cities: ["Faridabad", "Ballabhgarh"],
        },
        Karnal: {
          cities: ["Karnal", "Taraori"],
        },
        Hisar: {
          cities: ["Hisar", "Hansi"],
        },
        Panipat: {
          cities: ["Panipat", "Samalkha"],
        },
        Sonipat: {
          cities: ["Sonipat", "Gohana"],
        },
        Yamunanagar: {
          cities: ["Yamunanagar", "Jagadhri"],
        },
        Bhiwani: {
          cities: ["Bhiwani", "Loharu"],
        },
        Kurukshetra: {
          cities: ["Kurukshetra", "Shahbad"],
        },
        Jind: {
          cities: ["Jind", "Narwana"],
        },
        Kaithal: {
          cities: ["Kaithal", "Cheeka"],
        },
        Sirsa: {
          cities: ["Sirsa", "Ellenabad"],
        },
        Mahendragarh: {
          cities: ["Mahendragarh", "Narnaul"],
        },
        Rewari: {
          cities: ["Rewari", "Bawal"],
        },
        Palwal: {
          cities: ["Palwal", "Hodal"],
        },
        Jhajjar: {
          cities: ["Jhajjar", "Bahadurgarh"],
        },
        Fatehabad: {
          cities: ["Fatehabad", "Tohana"],
        },
        "Charkhi Dadri": {
          cities: ["Charkhi Dadri"],
        },
      },
    },
    Rajasthan: {
      districts: {
        Jaipur: {
          cities: ["Jaipur", "Sanganer", "Tonk"],
        },
        Jodhpur: {
          cities: ["Jodhpur", "Osian"],
        },
        Bikaner: {
          cities: ["Bikaner", "Deshnok"],
        },
        Ajmer: {
          cities: ["Ajmer", "Kishangarh"],
        },
        Udaipur: {
          cities: ["Udaipur", "Kumbhalgarh"],
        },
        Kota: {
          cities: ["Kota", "Bundi"],
        },
        Bharatpur: {
          cities: ["Bharatpur", "Deeg"],
        },
        Alwar: {
          cities: ["Alwar", "Bhiwadi"],
        },
        Chittorgarh: {
          cities: ["Chittorgarh", "Nimbahera"],
        },
        Jaisalmer: {
          cities: ["Jaisalmer", "Pokhran"],
        },
        Sikar: {
          cities: ["Sikar", "Fatehpur"],
        },
        Barmer: {
          cities: ["Barmer", "Balotra"],
        },
        Pali: {
          cities: ["Pali", "Sojat"],
        },
        Tonk: {
          cities: ["Tonk", "Malpura"],
        },
        Nagaur: {
          cities: ["Nagaur", "Merta City"],
        },
        Dausa: {
          cities: ["Dausa", "Lalsot"],
        },
        Bhilwara: {
          cities: ["Bhilwara", "Shahpura"],
        },
        "Sawai Madhopur": {
          cities: ["Sawai Madhopur", "Gangapur City"],
        },
        Jhunjhunu: {
          cities: ["Jhunjhunu", "Pilani"],
        },
        Sirohi: {
          cities: ["Sirohi", "Mount Abu"],
        },
        Banswara: {
          cities: ["Banswara", "Kushalgarh"],
        },
        Dungarpur: {
          cities: ["Dungarpur", "Sagwara"],
        },
      },
    },
    "Uttar Pradesh": {
      districts: {
        Agra: {
          cities: ["Agra", "Fatehpur Sikri"],
        },
        Lucknow: {
          cities: ["Lucknow", "Malihabad"],
        },
        Varanasi: {
          cities: ["Varanasi", "Sarnath"],
        },
        Kanpur: {
          cities: ["Kanpur", "Bithoor"],
        },
        Noida: {
          cities: ["Noida", "Greater Noida"],
        },
        Ghaziabad: {
          cities: ["Ghaziabad", "Modinagar"],
        },
        Meerut: {
          cities: ["Meerut", "Modipuram"],
        },
        Allahabad: {
          cities: ["Allahabad", "Phulpur"],
        },
        Gorakhpur: {
          cities: ["Gorakhpur", "Kushinagar"],
        },
        Aligarh: {
          cities: ["Aligarh", "Khair"],
        },
        Mathura: {
          cities: ["Mathura", "Vrindavan"],
        },
        Bareilly: {
          cities: ["Bareilly", "Aonla"],
        },
        Saharanpur: {
          cities: ["Saharanpur", "Deoband"],
        },
        Firozabad: {
          cities: ["Firozabad", "Shikohabad"],
        },
        Moradabad: {
          cities: ["Moradabad", "Kundarki"],
        },
        Faizabad: {
          cities: ["Faizabad", "Ayodhya"],
        },
        Gonda: {
          cities: ["Gonda", "Nawabganj"],
        },
        Jhansi: {
          cities: ["Jhansi", "Mauranipur"],
        },
      },
    },
    Delhi: {
      districts: {
        CentralDelhi: {
          cities: ["Connaught Place", "Karol Bagh", "Daryaganj"],
        },
        NorthDelhi: {
          cities: ["Model Town", "Narela", "Civil Lines"],
        },
        SouthDelhi: {
          cities: ["Saket", "Hauz Khas", "Mehrauli"],
        },
        EastDelhi: {
          cities: ["Preet Vihar", "Mayur Vihar", "Laxmi Nagar"],
        },
        WestDelhi: {
          cities: ["Rajouri Garden", "Janakpuri", "Punjabi Bagh"],
        },
        NorthEastDelhi: {
          cities: ["Seelampur", "Yamuna Vihar", "Shahdara"],
        },
        SouthWestDelhi: {
          cities: ["Dwarka", "Najafgarh", "Palam"],
        },
        NorthWestDelhi: {
          cities: ["Rohini", "Pitampura", "Ashok Vihar"],
        },
        NewDelhi: {
          cities: ["Chanakyapuri", "Parliament House", "India Gate"],
        },
        Shahdara: {
          cities: ["Shahdara", "Dilshad Garden", "Vivek Vihar"],
        },
      },
    },
  },
};
